import React, { Component } from 'react'
import axios from 'axios'

class Timeout extends Component {
  render() {
    return (
      <>
        <section id="wrapper">
<div className="login-register" style={{backgroundImage:"url(assets/images/back_AFX.png)"}}>
  <div className="lgtop"><img src="assets/images/afxlogo.png"/></div>
  <div className="login-box1">

    <div className="card-body">
      <div style={{fontSize: "14px", color:"#fff"}}>
        
        <br/>
        <br/>

        <h1 style={{lineHeight:"35px"}} className="expiry_error">Session Time out. Please click on the link again.</h1>
        {/* <p style={{textAlign:"center"}}>The link sent has expired, click on the button below to send a new link.</p>
         */}
      </div>

      <div className="d-flex no-block align-items-center m-t-100">
        <div className="form-check">
          
        </div>
      </div>
    </div>

     {/* <div className="form-group text-center">
      <div className="col-md-8 offset-md-2">
        <a href="" style={{color:"white"}}><button className="btn btn-logs btn-lg btn-block text-uppercase waves-effect waves-light" type="submit">Send New Link</button></a>
      </div>
    </div> */}
    
  </div>
</div>
</section>
      </>
    )
  }
}

export default Timeout
